import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const PageHeaderStyles: moduleStyleType = {
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    headerSection: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        overflow: 'hidden',
    },
    title: {
        '.MuiAvatar-root': {
            margin: 0,
        },
        display: 'flex',
        alignItems: 'center',
    },
    field: {
        paddingBottom: 2,
    },
    statusAndMetadataContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 3,
    },
    padded: {
        paddingTop: 3,
        paddingBottom: 2,
        paddingLeft: 5,
        paddingRight: 5,
        backgroundColor: 'background.default',
        borderBottom: '1px solid',
        borderBottomColor: 'border.primary',
    },
}
